import { ERROR, SUCCESS, WARNING, INFO } from './message.resource';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AlertaService {
  private subject = new Subject<any>();

  constructor() {
    this.subject.next();
  }

  getMensaje(): Observable<any> {
    return this.subject.asObservable();
  }

  error(error: any) {
    if (error.status === 403 || error.status === 417) {
       window.location.href = error._body;
    } else if (error.status === 500){
        const mensajeError = 'ocurrio un error inesperado por favor contactar al administrador';
        this.subject.next({type: ERROR, text: mensajeError});
    } else {
      const mensajeError = 'ocurrio un error inesperado por favor contactar al administrador';
      this.subject.next({type: ERROR, text: mensajeError});
    }
  }

  errorMensaje(error: any) {
        const mensajeError = error;
        this.subject.next({type: ERROR, text: mensajeError});
  }

  exito(mensaje: string) {
    this.subject.next({type: SUCCESS, text: mensaje});
  }

  advertencia(mensaje: string) {
    this.subject.next({type: WARNING, text: mensaje});
  }

  info(mensaje: string) {
    this.subject.next({type: INFO, text: mensaje});
  }

  limpiarMensajes() {
    this.subject.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/alerta/alerta.service.ts